module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4f54696394286eb7a94c5dbc36930a89.png";